export const ENABLE_WATCH_RULE_NAME = "enable_watch_rule" as const;

export const ENABLE_WATCH_RULE_DESC = `Enables a Metric Watch rule.

Call list_watch_rules first and copy the exact complete rule snapshot into rule. The user reviews that bound snapshot, and its current configurationVersion remains the backend conflict token.

This write operation requires user approval.` as const;
